<mat-accordion [multi]="multi()">
  @for (panel of panels(); track panel) {
    <mat-expansion-panel
      class="mat-elevation-z0"
      (expandedChange)="panel.expanded.set($event)"
      [expanded]="panel.expanded()"
      [hideToggle]="panel.toggleHide()">
      <mat-expansion-panel-header>
        <mat-panel-title>
          @if (panel.icon()) {
            <ui-icon [faName]="panel.icon()!" [faStyle]="panel.iconStyle() ?? 'light'"></ui-icon>
          }
          <span>{{ panel.headline() }}</span>
        </mat-panel-title>
        @if (panel.description()) {
          <mat-panel-description>
            {{ panel.description() }}
          </mat-panel-description>
        }
      </mat-expansion-panel-header>
      <ng-container *ngTemplateOutlet="panel.template"></ng-container>
    </mat-expansion-panel>
  }
</mat-accordion>
